import { useQuery } from "@tanstack/react-query";
import AppContext from "PFApp/app_context";
import { useSession } from "PFApp/use_session";
import { QueryOptions } from "PFTypes/request_options";
import { useContext } from "react";

import { fetchSkillsHistData } from "../../../services/insights/skills_hist_api";
import { queryKeys } from "./query_keys";

export type SkillsHistData = {
  "Number of Users": number;
  "Skills per User": string;
  "account_id": number;
  "count_ranked_skills": number;
  "count_ranked_skills_grouped": number;
  "count_total_skills": number;
  "count_unranked_skills": number;
  "count_unranked_skills_grouped": number;
};

type SkillsDeltaData = {
  skills_hist: SkillsHistData[];
};

type UseSkillsDeltaQuery = {
  params: Record<string, any>;
};

export const useSkillsHistQuery = (
  { params }: UseSkillsDeltaQuery,
  options?: QueryOptions<SkillsDeltaData>
) => {
  const session = useSession();
  const {
    store: { currentAccount }
  } = useContext(AppContext);
  return useQuery<SkillsDeltaData>(
    queryKeys.skillsHist(params),
    async () => await fetchSkillsHistData(session.getAccessToken(), currentAccount.full_domain, params),
    options
  );
};
